import { Alert, AlertType, Icon } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ToastPosition, useToasts } from '~/stores/use-toasts/useToasts';
import { useChatNavigation } from '~/views/alfred/use-chat-navigation/useChatNavigation';

import researchStyles from '../Research.module.scss';

export const CONVERSATION_TOAST = 'CONVERSATION_TOAST';

export interface ToastContent {
  content: string;
  conversationId: string;
  messageId: string;
  enableToastHiding?: boolean;
}

export const useNotificationToast = () => {
  const { t } = useTranslation(['chat']);
  const { navigateToConversation } = useChatNavigation();

  const { showToast } = useToasts(state => ({
    showToast: state.showToast,
  }));

  const showNotificationToast = ({
    content,
    conversationId,
    messageId,
    enableToastHiding = true,
  }: ToastContent) => {
    showToast({
      id: `conversation-toast-${messageId}`,
      hideToast: enableToastHiding,
      position: ToastPosition.TopRight,
      content: (
        <Alert
          className={researchStyles.styledAlert}
          data-testid="notification-toast"
          type={AlertType.Info}
          title={t('chat:notification.title')}
          message={<p className={researchStyles.toastContent}>{content}</p>}
          onClose={() => {}}
          withIcon
          customIcon={
            <Icon fillColor="var(--icon-primary)" iconName="Alfred" size={20} />
          }
          primaryBtn={{
            label: t('chat:notification.goToChat'),
            onClick: () => {
              navigateToConversation(conversationId);
            },
          }}
        />
      ),
      scope: CONVERSATION_TOAST,
    });
  };

  return { showNotificationToast };
};
